import { notification } from 'components/Notification'
import { TCompleteRebatesPaymentData } from './types'
import { VALIDATION_MESSAGES } from 'constants/txt'

export const validateCompleteRebatesPaymentData = (
  data: TCompleteRebatesPaymentData
) => {
  if (!data.has_receivable_account || !data.has_default_receivable_account) {
    notification.error({
      message: VALIDATION_MESSAGES.SM0243
    })
    return false
  }
  return true
}
